import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset window scroll to the top on every route change.
 *
 * React Router v6 preserves the window scroll position across navigations by
 * default, so navigating from a scrolled-down page (e.g. tapping Diagnose far
 * down the plant detail page) opened the next page already scrolled halfway
 * down. Rendered once inside the router; returns nothing.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
